import React, {Component} from 'react'
import PropTypes, { object } from 'prop-types'
import { connect } from 'react-redux'

// Actions
import { postCategory, ESGLevelTypes, ESGScopeTypes } from '../../../../../actions/esg'

// Utils
import { translation } from '../../../../../utils/helpers'

// Elements
import { ElementIcons } from '../../../../../shared/elements/icons'
import Text from '../../../../../shared/elements/text'
import RemoveButton from '../../../../../shared/elements/removeButton'
import TableRow from '../../../../../shared/elements/tableRow'
// import Label from '../../../../../shared/elements/label'
import AddButton from '../../../../../shared/elements/addButton'
// import Inline from '../../../../../shared/elements/inline'
import Lines from './lines'
import IconCycle from '../../../../../shared/elements/iconCycle'

const EntryRestriction = { Hide: 0, CanSee: 1, CanEnterData: 2 }
class Categories extends Component {
  constructor (props) {
    super(props)
    this.resetNewCategory = {
      Name: '',
      EntryName: '',
      UnitName: '',
      UnitConversionName: '',
      CompanyEntryRestriction: 2,
      CompanyUnitRestriction: 1,
      CompanyConversionRestriction: 1
    }

    this.restrictionIconSize = '16px'
    this.defaultCols = ['2fr', '1fr', this.restrictionIconSize, '1fr', this.restrictionIconSize, '2fr', this.restrictionIconSize, 'min-content']
    this.manualReportingCols = ['auto', 'min-content']
    this.iconCycleList = [ { icon: ElementIcons.Edit, value: EntryRestriction.CanEnterData }, { icon: ElementIcons.Show, value: EntryRestriction.CanSee }, { icon: ElementIcons.Hide, value: EntryRestriction.Hide } ]
    this.state = {
      newCategory: {
        ...this.resetNewCategory
      }
    }
  }

  render () {
    let scopeType = this.props.scopeType

    const renderCategory = (category, index) => {
      const changeCategoryData = (data, shouldSave) => {
        let categories = [...this.props.categories]
        categories[index] = { ...category, ...data }
        if (categories[index].IsDeleted === true) categories.splice(index, 1)
        this.props.bubbleUpChange({ Categories: categories })
        if (shouldSave === true) saveCategory(categories[index]) // save immediatly if it was a checkbox
      }

      const saveCategory = (overWriteObj = undefined) => {
        let data = overWriteObj || category
        this.props.postCategory(data).then((res) => {
          changeCategoryData(res.data)
          // window.toastr.success(translation(893), translation('13424'))
        }, () => {
          window.toastr.error(translation(960), translation('216'))
        })
      }

      const deleteCategory = () => this.props.onDelete(ESGLevelTypes.Category, category.Id, () => saveCategory({ ...category, IsDeleted: true }))
      const onCategoryChange = ({ target: { value, name, type } }) => changeCategoryData({ [name]: value }, type === 'cycle')
      let hideEntry = category.CompanyEntryRestriction === EntryRestriction.Hide
      let hideUnit = category.CompanyUnitRestriction === EntryRestriction.Hide
      let hideAmount = category.CompanyConversionRestriction === EntryRestriction.Hide

      switch (scopeType) {
        case ESGScopeTypes.ManualReporting:
          return (
            <div key={index} className='pg-my-3'>
              {<Lines categoryId={category.Id} lines={category.Lines} scopeType={scopeType} bubbleUpChange={changeCategoryData} onDelete={this.props.onDelete} cols={this.manualReportingCols} />}
            </div>
          )
        case ESGScopeTypes.Default:
          return (
            <div key={index} className='pg-my-3'>
              <TableRow header cols={this.defaultCols} className='category-header'>
                <Text size='s' name='Name' value={category.Name} onChange={onCategoryChange} onBlur={() => saveCategory()} />
                <Text size='s' name='EntryName' value={category.EntryName} onChange={onCategoryChange} onBlur={() => saveCategory()} disabled={hideEntry} />
                <IconCycle size='t' icons={this.iconCycleList} name='CompanyEntryRestriction' value={category.CompanyEntryRestriction} onChange={onCategoryChange} />
                <Text size='s' name='UnitName' value={category.UnitName} onChange={onCategoryChange} onBlur={() => saveCategory()} disabled={hideUnit} />
                <IconCycle size='t' icons={this.iconCycleList} name='CompanyUnitRestriction' value={category.CompanyUnitRestriction} onChange={onCategoryChange} />
                <Text size='s' name='UnitConversionName' value={category.UnitConversionName} onChange={onCategoryChange} onBlur={() => saveCategory()} disabled={hideAmount} />
                {/* AP-3745: Independent unit and conversion column
                <Inline spacing={0}>
                  <Text size='s' name='UnitConversionName' value={category.UnitConversionName} onChange={onCategoryChange} disabled={hideAmount} />
                  <Label size='s'>{`/\u00A0` + category.UnitName}</Label>
                </Inline>
                */}
                <IconCycle size='t' icons={this.iconCycleList.slice(1)} name='CompanyConversionRestriction' value={category.CompanyConversionRestriction} onChange={onCategoryChange} />
                <RemoveButton size='s' onClick={deleteCategory} />
              </TableRow>
              {<Lines categoryId={category.Id} lines={category.Lines} scopeType={scopeType} bubbleUpChange={changeCategoryData} onDelete={this.props.onDelete} cols={this.defaultCols} hideEntry={hideEntry} hideUnit={hideUnit} hideAmount={hideAmount} />}
            </div>
          )
        default:
          throw new Error(`Scope type: ${scopeType} is not implemented!`)
      }
    }

    const renderAddCategory = (category) => {
      if (scopeType === ESGScopeTypes.ManualReporting) return null

      const addCategory = () => {
        let data = { ...category, scopeId: this.props.scopeId }
        this.props.postCategory(data).then((res) => {
          this.props.bubbleUpChange({ Categories: [...this.props.categories, res.data] })
          this.setState({ newCategory: { ...this.resetNewCategory } })
          // window.toastr.success(translation(18410), translation('13424'))
        }, () => {
          window.toastr.error(translation(18411), translation('216'))
        })
      }

      const onCategoryChange = ({ target: { value, name } }) => this.setState({ newCategory: { ...category, [name]: value } })
      let hideEntry = category.CompanyEntryRestriction === 0
      let hideUnit = category.CompanyUnitRestriction === 0
      let hideAmount = category.CompanyConversionRestriction === 0
      return (
        <TableRow header cols={this.defaultCols} className='category-header'>
          <Text size='s' name='Name' value={category.Name} onChange={onCategoryChange} />
          <Text size='s' name='EntryName' value={category.EntryName} onChange={onCategoryChange} disabled={hideEntry} />
          <IconCycle size='t' icons={this.iconCycleList} name='CompanyEntryRestriction' value={category.CompanyEntryRestriction} onChange={onCategoryChange} />
          <Text size='s' name='UnitName' value={category.UnitName} onChange={onCategoryChange} disabled={hideUnit} />
          <IconCycle size='t' icons={this.iconCycleList} name='CompanyUnitRestriction' value={category.CompanyUnitRestriction} onChange={onCategoryChange} />
          <Text size='s' name='UnitConversionName' value={category.UnitConversionName} onChange={onCategoryChange} disabled={hideAmount} />
          {/* AP-3745: Independent unit and conversion column
          <Inline spacing={0}>
            <Text size='s' name='UnitConversionName' value={category.UnitConversionName} onChange={onCategoryChange} disabled={hideAmount} />
            <Label size='s'>{`/\u00A0` + category.UnitName}</Label>
          </Inline>
          */}
          <IconCycle size='t' icons={this.iconCycleList.slice(1)} name='CompanyConversionRestriction' value={category.CompanyConversionRestriction} onChange={onCategoryChange} />
          <AddButton size='s' onClick={addCategory} />
        </TableRow>
      )
    }

    return (
      <div className='category-container'>
        {this.props.categories.map(renderCategory)}
        {renderAddCategory(this.state.newCategory)}
      </div>
    )
  }
}

Categories.propTypes = {
  scopeId: PropTypes.number.isRequired,
  bubbleUpChange: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(object).isRequired,
  onDelete: PropTypes.func.isRequired,
  scopeType: PropTypes.oneOf(Object.values(ESGScopeTypes)).isRequired
}

export default connect(null, { postCategory })(Categories)



// WEBPACK FOOTER //
// ./src/app/pages/ESG/Chain/View/components/categories.js